import API from "./api/api";

export const wrapConsole = () => {
  const { logsClient } = API;
  const wrapLog = (prop: "log" | "error" | "warn" | "debug" |"info" | "trace", level: "info" | "error" | "warn" | "debug" | "trace") => {
    const originalConsole = console[prop].bind(console);
    console[prop] = (...args) => {
      // prevent recursive calls due to errors in JSON.stringify or so
      const newConsole = console[prop];
      console[prop] = originalConsole;
      try {
        originalConsole(...args);
        logsClient.push({ level, message: JSON.stringify(args), location: window.location.href });
      } catch (err) {
        // ignore
      } finally {
        console[prop] = newConsole;
      }
    };
  };

  wrapLog("log", "info");
  wrapLog("info", "info");
  wrapLog("error", "error");
  wrapLog("warn", "warn");
  wrapLog("debug", "debug");
  wrapLog("trace", "trace");
};
